


import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { ExportHistoryProps, ExportHistoryResponse, GetHistoryProps, HistoryResponse } from "./models";

const getHistory = async ({ page, pageSize, targetName, startDate, endDate, creatorName, senderName, destinationAccountName }: GetHistoryProps): Promise<HistoryResponse> => {
    let config = getConfig();
    try {
        const createQueryParams = new URLSearchParams();
        createQueryParams.set('page', page.toString());
        createQueryParams.set('pageSize', pageSize.toString());
        createQueryParams.set('targetName', targetName);
        createQueryParams.set('startDate', startDate);
        createQueryParams.set('endDate', endDate);
        createQueryParams.set('creatorName', creatorName);
        createQueryParams.set('senderName', senderName);
        createQueryParams.set('destinationAccountName', destinationAccountName);
        const response = await axios.get<HistoryResponse>(`/history?${createQueryParams.toString()}`, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
};



const getAllHistoryExport = async ({ creatorName, targetName, startDate, endDate }: ExportHistoryProps): Promise<ExportHistoryResponse> => {
    const config = getConfig();
    try {
        // Construir la URL con los parámetros de consulta
        const url = `/history/export?page=1&pageSize=30000${creatorName ? `&creatorName=${creatorName}` : ''}${targetName ? `&targetName=${targetName}` : ''}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}`;
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        console.error(error);
        return { data: [], totalItems: 0, totalPages: 0, currentPage: 0 } as ExportHistoryResponse;
    }
}

export { getHistory, getAllHistoryExport } 